import {
  GOOGLE_AUTHENTICATOR,
  MICROSOFT_AUTHENTICATOR,
} from "../components/TwoFactorRequirement/utils/utils";

import TextLink from "../../../components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "../../../components/TextLink/types";

const useTwoFaContent = () => {
  const otpTopTitleComponents = {
    1: (
      <TextLink
        size={TEXT_LINK_SIZES.Normal}
        href={MICROSOFT_AUTHENTICATOR}
        target="_blank"
      >
        Microsoft Authenticator
      </TextLink>
    ),
    2: (
      <TextLink
        size={TEXT_LINK_SIZES.Normal}
        href={GOOGLE_AUTHENTICATOR}
        target="_blank"
      >
        Google Authenticator
      </TextLink>
    ),
  };

  return { otpTopTitleComponents };
};

export default useTwoFaContent;
